import { createFileRoute } from "@tanstack/react-router";
import { Loading } from "@/layouts/loading";
import Component from "@/routes/(pharma)/_layout/reports/expiry-list/-components/component";
import { pharmacyClient } from "@/connect";
import { GetInventoryResponse } from "@/gen/inventory/get_inventory_pb";
import { z } from "zod";
const SearchParams = z.object({
  page: z.number().default(1),
  pageSize: z.number().default(10),
});
type SearchParams = z.infer<typeof SearchParams>;

export const Route = createFileRoute("/(pharma)/_layout/reports/expiry-list/")({
  component: Component,
  validateSearch: SearchParams,
});
